import { render, staticRenderFns } from "./abbA4.vue?vue&type=template&id=6839dab8&"
import script from "./abbA4.vue?vue&type=script&lang=js&"
export * from "./abbA4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports